module.exports = __webpack_public_path__ + "static/media/whiteley.29bda557.png";